module.exports = __webpack_public_path__ + "img/6bda20080ce99f075c77ce91f7ee49d2.2a57e76f.png";